import { NonCapturedPaymentDto } from '../../../../generated-api'
import { extractValue } from '../utils/payloadUtils'

export const getReason = (nonCapturedPayment?: NonCapturedPaymentDto) => {
    if (!nonCapturedPayment) return ''

    const events = nonCapturedPayment.events
    const payloads = events.map((event) => event.payload).filter((payload) => payload !== undefined)
    const reasons = payloads.map((payload) => extractValue(payload ?? '', 'failureReason')).filter((reason) => !!reason)

    const uniqueReasons = [...new Set(reasons)]

    return uniqueReasons.join(', \n')
}
